import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FailcodeStore {

}

export enum FailcodeStoreKeys {

}
